import React, { useState, useEffect, useRef } from 'react';
import fnc from '../mymod/commFunction';
import './MaualList2.scss';

const MaualList2 = ({ selectedCategory, onSelectContent, refreshKey }) => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const listContainerRef = useRef(null);

    useEffect(() => {
        if (selectedCategory) {
            select_board_unit2(selectedCategory.unit1_code);
            // 새로운 카테고리 선택시 스크롤 위치를 맨 위로 이동
            if (listContainerRef.current) {
                listContainerRef.current.scrollTop = 0;
            }
        }
    }, [selectedCategory, refreshKey]);

    // 컴포넌트 마운트시 스크롤 위치 초기화
    useEffect(() => {
        if (listContainerRef.current) {
            listContainerRef.current.scrollTop = 0;
        }
    }, []);

    function select_board_unit2(pCode) {
        setLoading(true);
        fnc.sendAxios('/boardRoutes/select_board_unit2', { pCode }, (res) => {
            if (res && Array.isArray(res)) {
                const newList = res.map(item => ({
                    sno: item["sno"],
                    pCode: item["pCode"],
                    unit2_code: item["unit2_code"],
                    unit2_name: item["unit2_name"],
                    sort_order: item["sort_order"]
                }));
                setList(newList);
            } else {
                setList([]);
            }
            setLoading(false);
        });
    }

    const handleItemClick = (item) => {
        setActiveItem(item.sno);
        
        // content는 별도 API로 조회
        fnc.sendAxios('/boardRoutes/select_board_content', { unit2_code: item.unit2_code }, (res) => {
            if (res && res.length > 0) {
                const contentData = {
                    ...item,
                    content: res[0].content
                };
                onSelectContent?.(contentData);
            } else {
                // content가 없어도 빈 content로 전달
                const contentData = {
                    ...item,
                    content: ''
                };
                onSelectContent?.(contentData);
            }
        });
    };

    if (!selectedCategory) {
        return (
            <div className='MaualList2'>
                <div className="empty-state">
                    <p>좌측 메뉴에서 항목을 선택해주세요.</p>
                </div>
            </div>
        );
    }

    return (
        <div className='MaualList2'>
            <div className="header">
                <h2>{selectedCategory.unit1_name}</h2>
            </div>

            {loading ? (
                <div className="loading">로딩 중...</div>
            ) : (
                <div className="list-container" ref={listContainerRef}>
                    {list.length === 0 ? (
                        <div className="empty-message">
                            등록된 항목이 없습니다.
                        </div>
                    ) : (
                        <ul className="item-list">{list.map((item, index) => (
                                <li 
                                    key={item.sno}
                                    className={`list-item ${activeItem === item.sno ? 'active' : ''}`}
                                    onClick={() => handleItemClick(item)}
                                >
                                    <div className="item-header">
                                        <span className="item-number">{index + 1}</span>
                                        <h3>{item.unit2_name}</h3>
                                    </div>
                                    {item.content && (
                                        <div className="item-content">
                                            {item.content}
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default MaualList2;